'use strict';

import { pluginPermissions } from './pluginPermissions';
import Initializer from './components/Initializer';
import pluginId from './pluginId';
export default {
  register(app) {
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false,
      permissions: Object.values({
        ...pluginPermissions
      }).flat()
    });
  }
};